import React from 'react';
import { useTranslation } from 'react-i18next';
import { Spinner } from '@/components/ui/spinner';
import { cn } from '@/lib/utils';

interface LoadingProps {
  message?: string;
  fullScreen?: boolean;
}

const Loading: React.FC<LoadingProps> = ({ message, fullScreen = false }) => {
  const { t } = useTranslation();
  const displayMessage = message !== undefined ? message : t('common.loading');

  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-3",
        fullScreen ? "fixed inset-0 z-50 bg-background/80 backdrop-blur-sm" : "p-4"
      )}
    >
      <Spinner className="size-8 text-primary" />
      {displayMessage && (
        <p className="text-sm font-medium text-muted-foreground">{displayMessage}</p>
      )}
    </div>
  );
};

export default Loading;
